export const scape_report_permission= {
    required_permission:[ "view_scape", "view_parametricgroup", "view_parameter"]
}